module.exports = __webpack_public_path__ + "static/0002-30a9b4d148be3400d302b8e36a9a4d9d.png";